/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
import Vue from 'vue'
let doctorConsultRequestListApiUrl = root.doctorConsultRequestListApiUrl.link;
let lbilNgoListApiUrl = root.lbilNgoListApiUrl.link;
let lbilNgoInfoUpdateApiUrl = root.lbilNgoInfoUpdateApiUrl.link;
let lbilSGListApiUrl = root.lbilSGListApiUrl.link;
let lbilSGInfoUpdateApiUrl = root.lbilSGInfoUpdateApiUrl.link;
let lbilUsersListApiUrl = root.lbilUsersListApiUrl.link;
export default {
  state: {
    doctorConsultRequestState:{},
    doctorConsultPublicRequestState:{},
    getLBILNgoListState:{},
    getLBILSGListState:{},
    getLBILPublicSGListState:{},
    getLBILPublicNgoListState:{},
    getLbilUsersListState:{}
  },
  mutations: {
    doctorConsultPublicRequestMutation(state, value) {
      Vue.set(state, 'doctorConsultPublicRequestState', value);
    },
    doctorConsultRequestMutation(state, value) {
      Vue.set(state, 'doctorConsultRequestState', value);
    },
    getLBILNgoListMutation(state, value) {
      Vue.set(state, 'getLBILNgoListState', value);
    },
    getLBILPublicNgoListMutation(state, value) {
      Vue.set(state, 'getLBILPublicNgoListState', value);
    },
    getLBILSGListMutation(state, value) {
      Vue.set(state, 'getLBILSGListState', value);
    },
    getLBILPublicSGListMutation(state, value) {
      Vue.set(state, 'getLBILPublicSGListState', value);
    },
    getLbilUsersListMutation(state, value) {
      Vue.set(state, 'getLbilUsersListState', value);
    },
  },
  actions: {
    // Get LBIL Users LIST Func
    getLbilUsersListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilUsersListApiUrl).then(res => {
                context.commit('getLbilUsersListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get LBIL Public SG LIST Func
    getLbilPublicSGListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilSGListApiUrl + '?is_active=true').then(res => {
                context.commit('getLBILPublicSGListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get LBIL SG LIST Func
    getLbilSGListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilSGListApiUrl).then(res => {
                context.commit('getLBILSGListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Update Lbil SG Request List Funs
    updateLbilSGRequestListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(lbilSGInfoUpdateApiUrl + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get LBIL NGO LIST Func
    getLbilPublicNgoListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilNgoListApiUrl + '?is_active=true').then(res => {
                context.commit('getLBILPublicNgoListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get LBIL NGO LIST Func
    getLbilNgoListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilNgoListApiUrl).then(res => {
                context.commit('getLBILNgoListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Update Lbil Ngo Request List Funs
    updateLbilNgoRequestListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(lbilNgoInfoUpdateApiUrl + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Consult Doctor Request List Funs
    getConsultDoctorRequestPublicListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(doctorConsultRequestListApiUrl + '?is_active=true').then(res => {
                context.commit('doctorConsultPublicRequestMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Consult Doctor Request List Funs
    getConsultDoctorRequestListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(doctorConsultRequestListApiUrl).then(res => {
                context.commit('doctorConsultRequestMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Update Consult Doctor Request List Funs
    updateConsultDoctorRequestListFunc(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(doctorConsultRequestListApiUrl + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
  },
  getters: {
    doctorConsultRequestGetters: state => state.doctorConsultRequestState,
    getLBILNgoListGetters: state => state.getLBILNgoListState,
    getLBILSGListGetters: state => state.getLBILSGListState,
    getLBILPublicSGListGetters: state => state.getLBILPublicSGListState,
    getLBILPublicNgoListGetters: state => state.getLBILPublicNgoListState,
    doctorConsultPublicRequestGetters: state => state.doctorConsultPublicRequestState,
    getLbilUsersListGetters: state => state.getLbilUsersListState
  }
}